import CardPage4 from "./cardPage4";
import Title4 from "./title4";

export default function Page4(){
    return(
    <>
    <Title4/>
    <CardPage4/>
    </>
    )
}